import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "img" }
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["src", "alt"]

import ReasonItem from "../../UI/ReasonItem.vue";
import { onMounted, watch } from "vue";
import { computed, ref } from "@vue/reactivity";
import type { Ref, ComputedRef } from "vue";
import { get } from "lodash";
import { useMenuStore } from "@/store/pinia/menu";
import { isInViewport } from "@/composables/mobileWatcher";
import { handleResize } from "@/composables/resizeHandler";

// Define store

export default /*#__PURE__*/_defineComponent({
  props: {
    contentData: {
        type: Object,
    },
},
  setup(__props) {

const props = __props

/**
 * @author Tornike Jortmenadze (Jortsoft)
 */
const store = useMenuStore();
const { windowWidth } = handleResize();

// Define props


// Define global variables
const locoScrollY: ComputedRef<number> = computed(() => store.locoScrollY);
const activeElem: Ref<Boolean> = ref(false);
const mobileClass: Ref<Boolean> = ref(false);
const open: Ref<Boolean> = ref(false);
const maskActive: Ref<Boolean> = ref(false);

// Reactive data
const getData = computed(() => {
    const arr = get(props.contentData, "data.list");
    arr.forEach((item: any) => {
        item.activeImage = false;
    });
    return arr;
});

// Watcher
watch(locoScrollY, () => {
    if (
        document.querySelector(".project-overview-goals .labelMask") === null ||
        document.querySelector(".project-overview-goals .labelMask") ===
            undefined
    ) {
        return;
    }
    if (
        isInViewport(
            document.querySelector(".project-overview-goals .labelMask")
        )
    ) {
        window.setTimeout(enablePointer, 2000);
    }
});

// Custom functions
const fisableAllImages = (): void => {
    getData.value.forEach((item: any) => {
        item.activeImage = false;
    });
};
const changeImage = (item: any): void => {
    fisableAllImages();
    item.activeImage = true;
    maskActive.value = true;
    open.value = true;
    store.triggerUpdate = !store.triggerUpdate;
    window.setTimeout(() => {
        maskActive.value = false;
        store.triggerUpdate = !store.triggerUpdate;
    }, 600);
};
const enablePointer = (): void => {
    activeElem.value = true;
};
const mobileScroll = (): void => {
    document.getElementById("app").addEventListener("scroll", () => {
        if (
            isInViewport(
                document.querySelector(".project-overview-goals .labelMask")
            )
        ) {
            mobileClass.value = true;
        }
    });
};
const leaveFun = (): void => {
    if (windowWidth < 1024) {
        return;
    }
    open.value = false;
};

// Function expression
onMounted(() => {
    getData.value[0].activeImage = true;
    if (window.innerWidth < 1024) {
        mobileScroll();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["project-overview-goals", { 'is-inview': mobileClass.value }]),
    "data-scroll": ""
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["main innerContainer", { open: open.value }])
    }, [
      _createElementVNode("div", {
        class: "box",
        onMouseleave: leaveFun
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getData), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["reasonCont", { active: activeElem.value }]),
            key: index
          }, [
            _createVNode(ReasonItem, {
              item: item,
              index: index,
              activeElem: activeElem.value,
              lineRotation: true,
              onMouseenter: ($event: any) => (changeImage(item))
            }, null, 8, ["item", "index", "activeElem", "onMouseenter"])
          ], 2))
        }), 128))
      ], 32),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getData), (img, index) => {
            return (_openBlock(), _createElementBlock("picture", { key: index }, [
              _createElementVNode("source", {
                media: "(max-width:767px)",
                srcset: _ctx.$get(img, 'images.0.devices.mobile')
              }, null, 8, _hoisted_3),
              _createElementVNode("source", {
                media: "(max-width:1023px)",
                srcset: _ctx.$get(img, 'images.0.devices.tablet')
              }, null, 8, _hoisted_4),
              _createElementVNode("img", {
                class: _normalizeClass({ active: img?.activeImage }),
                src: _ctx.$get(img, 'images.0.devices.desktop'),
                alt: _ctx.$get(img, 'iamges.0.title')
              }, null, 10, _hoisted_5)
            ]))
          }), 128))
        ])
      ])
    ], 2)
  ], 2))
}
}

})